import { render, staticRenderFns } from "./CopilotPanel.vue?vue&type=template&id=753a0c89"
import script from "./CopilotPanel.vue?vue&type=script&lang=js"
export * from "./CopilotPanel.vue?vue&type=script&lang=js"
import style0 from "./CopilotPanel.vue?vue&type=style&index=0&id=753a0c89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports